import { Button, Input, Table } from 'antd';
import styles from '../index.module.css';
import React, { useEffect, useState } from 'react';
import ActionTable from '../../../components/table/ActionTable';
import { useDispatch, useSelector } from 'react-redux';
import {
  deleteNetworksRequest,
  getNetworks,
} from '../../../store/actions/networks';
import { convertDateStringToFrenchFormat } from '../../../utils/functions';
import { Link } from 'react-router-dom';
import { SearchOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const Networks = () => {
  const { t } = useTranslation();
  const [dataSource, setDataSource] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { networks, loading } = useSelector((state) => state.networks);

  const [searchNetwork, setSearchNetwork] = useState('');

  const dispatch = useDispatch();

  const deleteAction = (id) => {
    dispatch(
      deleteNetworksRequest({
        id,
      })
    );
  };

  const columns = [
    {
      title: t('admin.networks.columns.name'),
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name),
      sortDirections: ['ascend', 'descend'],
    },
    {
      title: t('admin.networks.columns.vlan'),
      dataIndex: 'vlan',
      key: 'vlan',
    },
    {
      title: t('admin.networks.columns.mac'),
      dataIndex: 'mac',
      key: 'mac',
    },
    {
      title: t('admin.networks.columns.comments'),
      dataIndex: 'comments',
      key: 'comments',
    },
    {
      title: t('admin.networks.columns.eolDate'),
      dataIndex: 'eolDate',
      key: 'eolDate',
      sorter: (a, b) => a.eolDate.localeCompare(b.eolDate),
      sortDirections: ['ascend', 'descend'],
      render: (eolDate) => {
        if (eolDate) {
          return convertDateStringToFrenchFormat(eolDate);
        }
        return '-';
      },
    },
    {
      title: t('admin.networks.columns.lastUsedDate'),
      dataIndex: 'lastUsedDate',
      key: 'lastUsedDate',
      sorter: (a, b) => a.lastUsedDate.localeCompare(b.lastUsedDate),
      sortDirections: ['ascend', 'descend'],
      render: (lastUsedDate) => {
        if (lastUsedDate) {
          return convertDateStringToFrenchFormat(lastUsedDate);
        }
        return '-';
      },
    },
    {
      title: t('admin.networks.columns.actions'),
      key: 'actions',
      width: '10%',
      render: (text, record) => (
        <ActionTable
          record={record}
          link={'/admin/networks/'}
          deleteAction={deleteAction}
        />
      ),
    },
  ];

  const handleSearch = (e) => {
    setSearchNetwork(e);
  };

  useEffect(() => {
    if (!networks.length) {
      dispatch(getNetworks());
    } else {
      setIsLoading(loading);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const delayDebounceSearch = setTimeout(() => {
      const keys = [
        'name',
        'vlan',
        'mac',
        'comments',
        'eolDate',
        'lastUsedDate',
      ];
      if (searchNetwork) {
        const trimedSearchNetwork = searchNetwork.trim().toLowerCase();
        setDataSource(
          networks.filter((network, index) => {
            let isFound = false;
            keys.forEach((key) => {
              if (network[key]) {
                if (
                  network[key]
                    .toString()
                    .toLowerCase()
                    .includes(trimedSearchNetwork)
                ) {
                  isFound = true;
                } else if (
                  convertDateStringToFrenchFormat(network[key])
                    .toString()
                    .toLowerCase()
                    .includes(trimedSearchNetwork)
                ) {
                  isFound = true;
                }
              }
            });

            return isFound;
          })
        );
      } else {
        setDataSource(networks);
      }
    }, 500);
    return () => clearTimeout(delayDebounceSearch);
  }, [searchNetwork, networks]);

  useEffect(() => {
    setDataSource(networks);
    setIsLoading(loading);
  }, [loading, networks]);

  return (
    <div className={`${styles['admin-content']} ${styles['network-content']}`}>
      <div className={styles.table__header}>
        <h2 className={styles.table__title}>{t('admin.networks.title')}</h2>
        <div className={styles.table__search}>
          <Input
            placeholder={t('admin.networks.placeholder.search')}
            onChange={(e) => {
              handleSearch(e.target.value);
            }}
            value={searchNetwork}
            prefix={<SearchOutlined />}
            allowClear
          />
        </div>

        <Link to={'/admin/networks/add'}>
          <Button type='primary' className={styles.table__button}>
            {t('admin.networks.button.add')}
          </Button>
        </Link>
      </div>

      <Table
        className={styles.table}
        columns={columns}
        dataSource={dataSource}
        loading={isLoading}
        rowKey='id'
      />
    </div>
  );
};

export default Networks;
